import _ from "lodash"

import { ResponsesVM, TemplateVM } from "@cmodules/checklist/assets/data/types"

class Template extends TemplateVM {
  need_merge_request: boolean;
  relations: Record<string, any>;
  flat_global_items: Record<string, TemplateVM>
  global_items: Template[]
  response_sets: ResponsesVM;


  constructor(
    /** Assign a local template (Additional attributes from TemplateVM) */
    template: Partial<Template> = {},
    /** Assign TemplateVM (Template structure comes from API) */
    templateVM: Partial<TemplateVM> = {}
  ) {
    const {
      need_merge_request = false,
      relations = {},
      flat_global_items = {},
      global_items = [],
      response_sets = {}
    } = template

    super(templateVM)

    this.need_merge_request = need_merge_request
    this.relations = relations
    this.flat_global_items = flat_global_items
    this.global_items = global_items
    this.response_sets = !_.isEmpty(response_sets) ? response_sets : templateVM.responses || {}
  }
}

export { Template }
